import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import { toast } from "react-toastify";
import logo from "../assets/logo.png";
import { FaUserCircle, FaHome, FaSearch, FaSlidersH } from "react-icons/fa";
import API_BASE_URL from "../config";

const EmployeeNavbar = () => {
    const [openDropdown, setOpenDropdown] = useState(null);
    const [profile, setProfile] = useState({
        username: "Employee",
        role: "USER",
        photo: null,
    });
    const [navbarColor, setNavbarColor] = useState("#080235");

    const handleMouseEnter = (dropdown) => setOpenDropdown(dropdown);
    const handleMouseLeave = () => setOpenDropdown(null);
    const [companyLogo, setCompanyLogo] = useState(null);

    const navigate = useNavigate();
    const userId = localStorage.getItem("userId");
    const employeeId = localStorage.getItem("employeeId");
    const token = localStorage.getItem("token");


    //   useEffect(() => {
    //     console.log("🆔 User ID from storage:", userId);
    //     console.log("🧑 Employee ID from storage:", employeeId);
    //     console.log("🧑 token:", token);
    // }, [userId, employeeId, token]);



    const handleGoToTimesheet = () => {
        navigate("/timesheetgrid", { state: { employeeId } });
    };

    const activeRole =
        localStorage.getItem("activeRole") || "ROLE_USER";


    // 🔐 Authentication check
    useEffect(() => {
        const token = localStorage.getItem("token");
        const roles = JSON.parse(localStorage.getItem("roles") || "[]");

        if (!token) {
            toast.error("You must be logged in to access this page.");
            navigate("/");
            return;
        }

        // ✅ check user role
        if (!roles.includes("ROLE_USER")) {
            toast.error("You are not authorized to access this page.");
            navigate("/");
            return;
        }
    }, [navigate]);


    useEffect(() => {

        const token = localStorage.getItem("token");
        const userId = localStorage.getItem("userId");

        if (!token || !userId) return;

        fetch(`${API_BASE_URL}/api/appearance/${userId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then(res => res.json())
            .then(data => {
                if (data && data.navbarColor) {
                    setNavbarColor(data.navbarColor);
                }
            })
            .catch(err => console.log("Appearance fetch error:", err));

    }, []);


    // ✅ Load bootstrap CSS dynamically
    useEffect(() => {
        const bootstrapLink = document.createElement("link");
        bootstrapLink.rel = "stylesheet";
        bootstrapLink.href =
            "https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css";
        document.head.appendChild(bootstrapLink);

        const iconsLink = document.createElement("link");
        iconsLink.rel = "stylesheet";
        iconsLink.href =
            "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css";
        document.head.appendChild(iconsLink);

        return () => {
            bootstrapLink.remove();
            iconsLink.remove();
        };
    }, []);


    // 🟩 Fetch company info (logo)
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) return;

        fetch(`${API_BASE_URL}/api/company-info`, {
            headers: {
                Authorization: "Bearer " + token,
                "Content-Type": "application/json",
            },
        })
            .then((res) => res.json())
            .then((data) => {
                if (Array.isArray(data) && data.length > 0) {
                    const company = data[0];
                    if (company.logoPath) {
                        setCompanyLogo(`${API_BASE_URL}/${company.logoPath}`);
                    }
                }
            })
            .catch((err) => console.error("Company logo fetch error:", err));
    }, []);

    // ✅ Fetch employee name & photo
    // ✅ Fetch employee name & photo using /api/users/{id}
    useEffect(() => {
        const token = localStorage.getItem("token");
        const employeeId = localStorage.getItem("employeeId"); // Make sure this is set

        if (!token || !employeeId) return;

        fetch(`${API_BASE_URL}/api/users/${userId}`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((res) => res.json())
            .then((data) => {
                if (data) {
                    setProfile((prev) => ({
                        ...prev,
                        username: data.name || prev.username,
                        roles: data.roles || ["ROLE_USER"],
                        role: data.roles?.includes("ROLE_USER") ? "USER" : prev.role,
                    }));
                }
            })
            .catch((err) => console.error("Failed to fetch profile:", err));

        // Fetch profile photo
        fetch(`${API_BASE_URL}/api/employees/me/photo`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((res) => res.blob())
            .then((blob) => {
                if (blob.size > 0) {
                    setProfile((prev) => ({
                        ...prev,
                        photo: URL.createObjectURL(blob),
                    }));
                }
            })
            .catch(() => console.log("No profile photo found"));
    }, []);



    return (
        <>
            {/* 🔹 Top White Bar */}
            <div
                className="d-flex align-items-center justify-content-between px-3 py-2 shadow-sm position-relative"
                style={{ backgroundColor: "#fff", borderBottom: "1px solid #ddd" }}
            >
                {/* Left: Logo */}
                <div className="d-flex align-items-center">
                    <img src={logo} style={{ height: "40px", marginRight: "45px" }} />

                    {/* Company Logo (from API) */}
                    {companyLogo && (
                        <img
                            src={companyLogo}
                            alt="Company Logo"
                            style={{
                                height: "40px",
                                width: "auto",
                                objectFit: "contain",
                                borderRadius: "6px",
                            }}
                        />
                    )}
                </div>

                {/* Right: Icons + Profile */}
                <div className="d-flex align-items-center gap-3">
                    <a
                        href="/empdashboard"
                        className="text-decoration-none text-dark  d-flex align-items-center"
                    >
                        <FaHome className="me-1" size={23} />
                    </a>
                    <a
                        href="/empsettingpage"
                        className="text-decoration-none text-dark fw-semibold d-flex align-items-center"
                    >
                        <FaSlidersH className="me-1" size={19} /> Settings
                    </a>

                    {/* 🔹 Profile Hover Dropdown */}
                    <div
                        className="position-relative"
                        onMouseEnter={() => setOpenDropdown("profile")}
                        onMouseLeave={handleMouseLeave}
                    >
                        <span
                            className="d-flex align-items-center text-dark"
                            style={{ cursor: "pointer" }}
                        >
                            <img
                                src={profile.photo || "https://via.placeholder.com/24"}
                                alt="Profile"
                                style={{
                                    width: "37px",
                                    height: "37px",
                                    borderRadius: "50%",
                                    marginRight: "8px",
                                }}
                            />
                            <div className="d-flex flex-column fw-semibold">
                                <span>{profile.username}</span>
                                {/* <small className="text-muted">{profile.role}</small> */}
                            </div>
                        </span>



                        {openDropdown === "profile" && (
                            <div
                                className="dropdown-menu show p-2"
                                style={{
                                    position: "absolute",
                                    top: "100%",
                                    right: 0,
                                    zIndex: 2000,
                                    minWidth: "220px",
                                }}
                            >
                                {/* Profile Settings */}
                                <a className="dropdown-item" href="/editprofile">
                                    Profile Settings
                                </a>
                                <div className="dropdown-divider"></div>

                                {/* Switch Role - Only show if user has more than 1 role */}
                                {profile.roles && profile.roles.length > 1 && (
                                    <div className="px-2">
                                        <h6 className="text-muted fw-bold mb-2">Switch Role</h6>
                                        <table className="table table-sm mb-2">
                                            <tbody>
                                                {profile.roles
                                                    .filter((role) => role !== activeRole)
                                                    .map((role, idx) => {
                                                        let path = "/";
                                                        if (role === "ROLE_MANAGER") path = "/managerdashboard";
                                                        if (role === "ROLE_ADMIN") path = "/admindashboard";
                                                        if (role === "ROLE_USER") path = "/empdashboard";

                                                        return (
                                                            <tr key={idx}>
                                                                <td>
                                                                    <a
                                                                        href={path}
                                                                        className="text-decoration-none d-block"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            localStorage.setItem("activeRole", role);
                                                                            setProfile((prev) => ({
                                                                                ...prev,
                                                                                role: role.replace("ROLE_", ""),
                                                                            }));
                                                                            navigate(path); // Navigate to the selected role's dashboard
                                                                        }}
                                                                    >
                                                                        {role.replace("ROLE_", "")}
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                            </tbody>
                                        </table>
                                    </div>
                                )}

                                <div className="dropdown-divider"></div>
                                <a
                                    className="dropdown-item text-danger"
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();

                                        sessionStorage.clear();
                                        localStorage.clear();

                                        navigate("/");
                                    }}

                                >
                                    Logout
                                </a>
                            </div>
                        )}


                    </div>
                </div>
            </div>

            {/* 🔹 Main Navbar */}

            <>
                <style>
                    {`
      .navbar .dropdown-toggle::after {
        display: none !important;
      }
    `}
                </style>
                <Navbar
                    expand="lg"
                    variant="dark"
                    className="shadow-sm"
                    style={{
                        backgroundColor: navbarColor,
                        paddingTop: "0.05rem",
                        paddingBottom: "0.05rem",
                        minHeight: "40px",
                    }}
                >
                    <Container fluid>
                        <Navbar.Toggle aria-controls="employee-navbar-nav" />
                        <Navbar.Collapse id="employee-navbar-nav">
                            <Nav className="me-auto fw-semibold">
                                {/* Tasks */}
                                <NavDropdown
                                    title={
                                        <span style={{ color: "#ffffff", fontWeight: "600" }} onClick={() => navigate("/employeetasklanding")}>
                                            Tasks
                                        </span>
                                    }
                                    id="tasks-dropdown"
                                    show={openDropdown === "tasks"}
                                    onMouseEnter={() => handleMouseEnter("tasks")}
                                    onMouseLeave={handleMouseLeave}
                                >
                                    <NavDropdown.Item href="viewtasks">
                                        My Tasks
                                    </NavDropdown.Item>
                                    {/* <NavDropdown.Item href="#">
                                        Abc
                                    </NavDropdown.Item> */}
                                </NavDropdown>

                                {/* Timesheets */}
                                <NavDropdown
                                    title={
                                        <span style={{ color: "#ffffff", fontWeight: "600" }} onClick={() => navigate("/employeetimesheetlanding")}>
                                            Timesheets
                                        </span>
                                    }
                                    id="timesheets-dropdown"
                                    show={openDropdown === "timesheets"}
                                    onMouseEnter={() => handleMouseEnter("timesheets")}
                                    onMouseLeave={handleMouseLeave}
                                >
                                    <NavDropdown.Item onClick={handleGoToTimesheet}>
                                        My Timesheets
                                    </NavDropdown.Item>
                                    {/* <NavDropdown.Item href="#">
                                        Abc
                                    </NavDropdown.Item> */}
                                </NavDropdown>

                                {/* Documents */}
                                <NavDropdown
                                    title={
                                        <span style={{ color: "#ffffff", fontWeight: "600" }} onClick={() => navigate("/employeedocumentslanding")}>
                                            Documents
                                        </span>
                                    }
                                    id="docs-dropdown"
                                    show={openDropdown === "docs"}
                                    onMouseEnter={() => handleMouseEnter("docs")}
                                    onMouseLeave={handleMouseLeave}
                                >
                                    <NavDropdown.Item href="uploaddocuments">
                                        Upload Documents
                                    </NavDropdown.Item>
                                    <NavDropdown.Item href="viewdocuments">
                                        My Documents
                                    </NavDropdown.Item>
                                </NavDropdown>


                                {/* Leave */}
                                <NavDropdown
                                    title={
                                        <span style={{ color: "#ffffff", fontWeight: "600" }} onClick={() => navigate("/employeeleavelanding")}>
                                            Leave
                                        </span>
                                    }
                                    id="docs-dropdown"
                                    show={openDropdown === "leave"}
                                    onMouseEnter={() => handleMouseEnter("leave")}
                                    onMouseLeave={handleMouseLeave}
                                >
                                    <NavDropdown.Item href="/leave">
                                        Leave Application
                                    </NavDropdown.Item>
                                    <NavDropdown.Item href="/allleaves">
                                        My Leaves
                                    </NavDropdown.Item>
                                    {/* <NavDropdown.Item href="#">
                                        Abc
                                    </NavDropdown.Item> */}
                                </NavDropdown>

                                {/* Details */}
                                <NavDropdown
                                    title={
                                        <span style={{ color: "#ffffff", fontWeight: "600" }} onClick={() => navigate("/employeedetailslanding")}>
                                            Details
                                        </span>
                                    }
                                    id="docs-dropdown"
                                    show={openDropdown === "details"}
                                    onMouseEnter={() => handleMouseEnter("details")}
                                    onMouseLeave={handleMouseLeave}
                                >
                                    <NavDropdown.Item onClick={(e) => {
                                        e.preventDefault();
                                        navigate("/viewdetails", { state: { employeeId } });
                                    }}>
                                        View Details
                                    </NavDropdown.Item>
                                    <NavDropdown.Item href="/holidays">
                                        Holiday Calendar
                                    </NavDropdown.Item>
                                </NavDropdown>
                            </Nav>

                            {/* 🔹 Search Bar */}
                            <div
                                className="ms-auto d-flex align-items-center"
                                style={{ maxWidth: "250px", width: "100%" }}
                            >
                                <div
                                    className="d-flex align-items-center border rounded px-2 w-100"
                                    style={{ background: "#fff" }}
                                >
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="form-control border-0"
                                        style={{ boxShadow: "none" }}
                                    />
                                    <FaSearch style={{ color: "#666" }} />
                                </div>
                            </div>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </>
        </>
    );
};

export default EmployeeNavbar;
